import React from 'react'
import { Icon as IconLoyal } from 'loyal-react'
import PropTypes from 'prop-types'

const getIconNameByStatus = status => {
  switch (status) {
    case '1':
    case '2':
    case '6':
    case '9':
    case '10':
    case '5':
      return 'icon_check_circle'
    case '3':
    case '4':
    case '8':
    case '7':
      return 'icon_truck'
    default:
      return ''
  }
}

const getIconClassNameByStatus = status => {
  switch (status) {
    case '1':
    case '2':
    case '3':
    case '4':
    case '5':
      return `color-success icon-md`
    case '6':
    case '7':
    case '8':
    case '9':
    case '10':
      return `color-error icon-md`
    default:
      return 'icon-md'
  }
}

const Icon = ({ status, when }) =>
  getIconNameByStatus(status) ? (
    getIconClassNameByStatus(when && status) === 'color-success icon-md' || getIconClassNameByStatus(when && status) === 'color-error icon-md'
      ? (<IconLoyal
        iconName={getIconNameByStatus(status)}
        className={getIconClassNameByStatus(when && status)}
      />) : <div className='row px-half py-half mx-0'><div className='col-auto py-half px-half bg-ui-2 radius-circle' aria-hidden='true' /></div>
  ) : (
    ''
  )

Icon.propTypes = {
  status: PropTypes.string,
  when: PropTypes.string
}

export default Icon



// WEBPACK FOOTER //
// ./src/App/Header/Tracking/Item/Status/Icon.js